import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import Div100vh from "react-div-100vh";
import Link from "next/link";
import classnames from "classnames";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import CVComposition from "@/components/CVComposition";
import DoneGreyIcon from "@/components/Icons/DoneGrey";
import styles from "./styles.module.scss";
import { HeaderWithExitModal } from "@/components/Header";
import { endLoadingState } from "@/utils/loading";
import { privateRoutes } from "@/routes";
import { isMobileDomain } from "@/utils/urls";
const benefits = ["Automatische Datenextraktion", "Schnell und einfach", "Anschließend frei anpassbar"];
interface UploadCVPropsType {
  children: React.ReactElement;
}

// Layout component for "/complete" (onStartPage) and "/complete/upload/[uploadID]/[token]/[fileName]/[fileSize] (onFilePreviewPage) pages"
function UploadCV(t0) {
  const $ = _c(55);
  const {
    children
  } = t0;
  const router = useRouter();
  isMobileDomain();
  const {
    t
  } = useTranslation();
  const uploadRef = React.useRef(null);
  const onFilePreviewPage = router.pathname === "/complete/upload/[uploadId]/[token]/[fileName]/[fileSize]";
  const onStartPage = router.pathname === "/complete";
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  React.useEffect(_temp, t1);
  let t2;
  let t3;
  if ($[1] !== onFilePreviewPage || $[2] !== onStartPage) {
    t2 = () => {
      if (uploadRef.current) {
        const element = uploadRef.current;
        if (onFilePreviewPage) {
          if (element.firstElementChild) {
            element.style.height = element.firstElementChild.scrollHeight + "px";
          }
        } else {
          if (onStartPage) {
            element.removeAttribute("style");
          }
        }
      }
    };
    t3 = [onFilePreviewPage, onStartPage];
    $[1] = onFilePreviewPage;
    $[2] = onStartPage;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  React.useEffect(t2, t3);
  let t4;
  if ($[5] !== onFilePreviewPage) {
    t4 = classnames(styles.upload, {
      [styles.unfold]: onFilePreviewPage
    });
    $[5] = onFilePreviewPage;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const uploadClass = t4;
  let t5;
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <HeaderWithExitModal showCloseButton={true} />;
    t6 = classnames(styles.uploadStatusContainer, "pb-3.5 mt-20 md:mt-28 xl:mt-32");
    $[7] = t5;
    $[8] = t6;
  } else {
    t5 = $[7];
    t6 = $[8];
  }
  let t7;
  if ($[9] !== onStartPage) {
    t7 = <CVComposition className={styles.cv} animate={onStartPage} />;
    $[9] = onStartPage;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = classnames(styles.paper, styles.uploadCvPaper, "self-center w-full max-w-screen-md ");
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t) {
    t9 = t("Erstellen Sie Ihr Profil");
    $[12] = t;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t9) {
    t10 = <div className={styles.uploadTitle}>{t9}</div>;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t) {
    t11 = t("direkt aus Ihrem Lebenslauf");
    $[16] = t;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t11) {
    t12 = <div className={styles.uploadSubtitle}>{t11}</div>;
    $[18] = t11;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t) {
    t13 = benefits.map(benefit => <div className={styles.benefitEntry} key={benefit}><DoneGreyIcon /><span className={styles.benefitText}>{t(benefit)}</span></div>);
    $[20] = t;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== t13) {
    t14 = <div className={styles.benefits}>{t13}</div>;
    $[22] = t13;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t10 || $[25] !== t12 || $[26] !== t14) {
    t15 = <div className={styles.uploadIntro}>{t10}{t12}{t14}</div>;
    $[24] = t10;
    $[25] = t12;
    $[26] = t14;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== children || $[29] !== uploadClass) {
    t16 = <div ref={uploadRef} className={uploadClass}>{children}</div>;
    $[28] = children;
    $[29] = uploadClass;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== t15 || $[32] !== t16) {
    t17 = <div className={t8}>{t15}{t16}</div>;
    $[31] = t15;
    $[32] = t16;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = classnames(styles.paper, styles.manualCvPaper, "self-center w-full max-w-screen-md");
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] !== t) {
    t19 = t("Sie haben keinen CV verf\xFCgbar?");
    $[35] = t;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  let t20;
  if ($[37] !== t19) {
    t20 = <div className={styles.manualTitle}>{t19}</div>;
    $[37] = t19;
    $[38] = t20;
  } else {
    t20 = $[38];
  }
  let t21;
  if ($[39] !== t) {
    t21 = t("Tragen Sie Ihre Daten einfach direkt in Ihr Profil ein.");
    $[39] = t;
    $[40] = t21;
  } else {
    t21 = $[40];
  }
  let t22;
  if ($[41] !== t21) {
    t22 = <p className={styles.manualText}>{t21}</p>;
    $[41] = t21;
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  let t23;
  if ($[43] !== t) {
    t23 = t("Jetzt Profil ausf\xFCllen");
    $[43] = t;
    $[44] = t23;
  } else {
    t23 = $[44];
  }
  let t24;
  if ($[45] !== t23) {
    t24 = <Link className={styles.link} href={privateRoutes.profile.root}>{t23}</Link>;
    $[45] = t23;
    $[46] = t24;
  } else {
    t24 = $[46];
  }
  let t25;
  if ($[47] !== t20 || $[48] !== t22 || $[49] !== t24) {
    t25 = <div className={t18}>{t20}{t22}{t24}</div>;
    $[47] = t20;
    $[48] = t22;
    $[49] = t24;
    $[50] = t25;
  } else {
    t25 = $[50];
  }
  let t26;
  if ($[51] !== t17 || $[52] !== t25 || $[53] !== t7) {
    t26 = <Div100vh>{t5}<div className={t6}>{t7}{t17}{t25}</div></Div100vh>;
    $[51] = t17;
    $[52] = t25;
    $[53] = t7;
    $[54] = t26;
  } else {
    t26 = $[54];
  }
  return t26;
}
function _temp() {
  endLoadingState();
}
export default UploadCV;